import React from "react";
import { Col as AntCol } from "antd";
import { ColProps as AntColProps } from "antd/lib/col";

export const Col = (props: AntColProps) => {
  const { children, ...rest } = props;
  return <AntCol {...rest}>{children}</AntCol>;
};
